var _title, _title2, _title3, _title4, _title5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeetcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 440 440",
    enableBackground: "new 0 0 440 440",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1.470559, 0, 0, 1.470559, -0.862376, -0.04182)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "logo")), /*#__PURE__*/React.createElement("g", {
    style: {}
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "left")), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(53, 53, 53)"
    },
    d: "M 44.639 134.134 C 42.467 134.031 165.727 11.73 165.95 11.507 C 182.703 -5.246 205.95 19.385 192.156 33.179 L 70.453 155.817 C 59.436 167.513 62.554 189.2 69.584 197.828 L 122.377 251.48 C 133.023 262.126 129.251 273.583 120.772 278.775 C 114.739 282.47 105.826 283.298 100.482 277.511 L 47.381 225.057 C 22.724 199.539 24.839 155.541 44.639 134.134 Z"
  })), /*#__PURE__*/React.createElement("g", null, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", null, "top")), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      paintOrder: "stroke",
      vectorEffect: "non-scaling-stroke",
      strokeWidth: 0,
      fill: "rgb(248, 160, 20)"
    },
    d: "M 120.978 104.891 C 144.857 88.84 161.502 97.479 173.741 110.401 C 183.111 120.294 192.017 128.575 198.479 135.058 C 210.854 147.474 239.133 128.697 220.347 109.647 C 205.673 94.766 194.177 82.851 191.219 80.126 C 180.99 71.534 173.101 65.931 161.308 64.277 L 120.978 104.891 Z"
  })), /*#__PURE__*/React.createElement("g", null, _title4 || (_title4 = /*#__PURE__*/React.createElement("title", null, "middle")), /*#__PURE__*/React.createElement("rect", {
    x: 118.634,
    y: 161.048,
    width: 152.407,
    height: 33.341,
    style: {
      fill: "rgb(216, 216, 216)"
    },
    rx: 16.67,
    ry: 16.67
  })), /*#__PURE__*/React.createElement("g", null, _title5 || (_title5 = /*#__PURE__*/React.createElement("title", null, "bottom")), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(248, 160, 20)"
    },
    d: "M 102.83 279.509 C 121.376 287.434 138.607 267.467 122.078 251.198 C 149.681 268.886 166.748 251.828 179.349 239.092 C 188.12 230.228 195.089 222.284 200.664 218.004 C 213.126 208.435 235.827 227.044 223.231 242.151 C 209.715 258.361 192.46 274.34 186.362 278.748 C 163.999 294.91 135.519 300.777 102.83 279.509 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeetcode);
export default __webpack_public_path__ + "static/media/Leetcode.f1283f4de8a7832356e92cb0d3040eae.svg";
export { ForwardRef as ReactComponent };